// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__4TDBa","main":"Layout_main__1RsEz"};